<template>
  <div class="inquire">
    <div class="list-header">
      <div class="header-bg">
        <div class="title">订单查询</div>
        <div class="search">
          <p class="subtitle">输入订单，查询状态</p>
          <div class="search-row">
            <div class="search-input">
              <van-icon class="el-icon-search" name="search" color="#b2b2b2" />
              <input @input="changeNum" v-model="orderText" type="text" placeholder="请输入订单号" />
            </div>
            <span class="search-btn" @click="search">查询</span>
          </div>
        </div>
        <p class="name"><van-icon class="wap-home" name="wap-home" />先锋团</p>
      </div>
    </div>
    <div class="tips">
      <p class="system-name">先锋团订单查询系统</p>
      <p>1. 可查询京东、淘宝平台的订单是否跟团成功。</p>
      <p>2. 京东订单请在付款前查询，避免退款国补失效。</p>
      <p>3. 提交订单后3-5分钟再查询，确保系统抓取正常。</p>
      <p>4. 如查询结果显示“无该订单信息”为跟团失败，需取消重拍。</p>
      <p>5. 如订单仅显示赠品/凑单品，不显示主商品为无效订单，需取消重拍。</p>
      <p>6. 如订单状态显示“待付款”“已付款”或“已完成”即为跟团成功，可付款。</p>
      <p>7. 成功跟团后截图保存，并将订单号发送到群内回复跟团成功，以便团长联系。</p>
      <p>8. 付款后订单号可能会更新，请使用最新订单号查询。</p>
      <p>9. 下单时请勿使用京东e卡、京豆、京享礼金及返利软件，避免影响返卡。</p>
      <p>10. 如有疑问，请在团购群联系团长咨询。</p>
    </div>
  </div>
</template>

<script>
import { checkInt } from '../utils/common'

export default {
  name: 'ListPage',
  components: {},
  data() {
    return {
      orderText: ''
    }
  },
  methods:{
    changeNum(){
      this.orderText = this.orderText ? checkInt(this.orderText) : null;
    },
    search(){
      this.$emit('search', this.orderText);
    }
  }
}
</script>

<style scoped>
.inquire {
  height: 100%;
  background: #f8f8f8;
  overflow-x: hidden;
  overflow-y: scroll;
}
.list-header {
  height: 9.5rem;
  background: linear-gradient(180deg, #e93e37, #f3705e);
  border-radius: 0 0 1rem 1rem;
  position: relative;
}
.header-bg {
  background: url("../assets/images/bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.title {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  padding-top: 1.5rem;
  padding-bottom: 0.3rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.search {
  width: 100%;
  padding: 0 0.8rem;
}
.subtitle {
  width: 100%;
  text-align: center;
  font-weight: 700;
  color: #ffffff;
  font-size: 0.75rem;
  margin-bottom: 0.4rem;
}
.search-row {
  display: flex;
  align-items: center;
}
.search-input {
  flex: 1;
  height: 1.8rem;
  position: relative;
}
.search-input input {
  outline: none;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 1.8rem;
  padding: 0 1.8rem;
  font-size: 0.7rem;
  color: #333333;
}
.el-icon-search {
  position: absolute;
  font-size: 0.8rem;
  left: 0.6rem;
  top: 0.5rem;
  color: #b2b2b2;
}
.search-btn {
  width: 2.5rem;
  height: 1.6rem;
  background-color: #ffffff;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 0.7rem;
  font-weight: bold;
  margin-left: 0.5rem;
}
.name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 1rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
  margin-top: 0.3rem;
}
.wap-home {
  font-size: 1.2rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
  margin-right: 0.2rem;
}
.tips {
  border: 0.05rem double #e8e2e3;
  padding: 2rem 0.5rem 0.5rem;
  border-radius: 1rem;
  margin: 1.5rem 0.8rem;
  background: #fef5f6;
  position: relative;
}
.tips p {
  color: #666666;
  font-size: 0.7rem;
  margin-top: 0.5rem;
}
.system-name {
  width: 8rem;
  height: 2rem;
  position: absolute;
  top: -0.05rem;
  left: -0.05rem;
  background: linear-gradient(90deg, #f6584a, #fe6647);
  margin-top: 0 !important;
  border-radius: 1rem 0.25rem 1.5rem 0;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 0.75rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
